import { Accounting } from '~/types/api.model';
export function buildCustomerIdToDisplay(customers) {
    return customers.reduce((acc, customer)=>{
        acc[customer.id()] = customer.formattedDisplay();
        return acc;
    }, {});
}
function mappingFor(model, accounting, customerIdToDisplay) {
    var _customerIdToDisplay_integratedId;
    const integratedId = model.integratedId({
        accounting
    });
    return {
        accounting,
        display: integratedId != null ? (_customerIdToDisplay_integratedId = customerIdToDisplay[integratedId]) !== null && _customerIdToDisplay_integratedId !== void 0 ? _customerIdToDisplay_integratedId : null : null
    };
}
function toContactMappings(model, maps) {
    const mappings = [];
    if (maps.showQbo) mappings.push(mappingFor(model, Accounting.QBO, maps.qboCustomerIdToDisplay));
    if (maps.showXero) mappings.push(mappingFor(model, Accounting.Xero, maps.xeroCustomerIdToDisplay));
    return mappings;
}
function toContactCardContact(model, maps) {
    var _model_phone;
    return {
        id: model.id(),
        name: model.fullName(),
        email: model.email(),
        phone: (_model_phone = model.phone()) !== null && _model_phone !== void 0 ? _model_phone : '',
        mappings: toContactMappings(model, maps)
    };
}
export function toContactCardContacts(models, maps) {
    return models.map((model)=>toContactCardContact(model, maps));
}
